(function($){
  $(function(){
    
    $(".twentytwenty-container").twentytwenty({
    default_offset_pct: 0.5, // How much of the before image is visible when the page loads
    orientation: 'horizontal', // Orientation of the before and after images ('horizontal' or 'vertical')
    before_label: 'BEFORE', // Set a custom before label
    after_label: 'AFTER', // Set a custom after label
    no_overlay: false, //Do not show the overlay with before and after
    move_slider_on_hover: false, // Move slider on mouse hover?
    move_with_handle_only: false, // Allow a user to swipe anywhere on the image to control slider movement. 
    click_to_move: true // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
  });
    
    mobiscroll.settings = {
    theme: 'ios',
    themeVariant: 'light'
};

   
    
   $('.card-deck').mobiscroll().listview({
        stages: [{
            percent: -20,
            action: function (event, inst) {
                inst.remove(event.target);
                return false;
            }
        }, {
            percent: 20,
            action: function (event, inst) {
                inst.remove(event.target);
                return false;
            }
        }],
        actionable: false
    });

    $('.card-deck-cycle').mobiscroll().listview({
        stages: [{
            percent: -20,
            action: function (event, inst) {
                inst.move(event.target, 0);
                return false;
            }
        }, {
            percent: 20,
            action: function (event, inst) {
                inst.move(event.target, 0);
                return false;
            }
        }],
        actionable: false
    });

//-----------------Scrollview Cards Initialization ---------------------
    
       $('.redapple-card li').mobiscroll().card({
            lang: 'en',             // Specify language like: lang: 'pl' or omit setting to use default
            theme: 'ios',           // Specify theme like: theme: 'ios' or omit setting to use default
            themeVariant: 'light'   // More info about themeVariant: https://docs.mobiscroll.com/4-10-10/scrollview#opt-themeVariant
        });
    
        // Mobiscroll Scrollview initialization
        $('.redapple-card').mobiscroll().scrollview({
            lang: 'en',             // Specify language like: lang: 'pl' or omit setting to use default
            theme: 'ios',           // Specify theme like: theme: 'ios' or omit setting to use default
            themeVariant: 'light',  // More info about themeVariant: https://docs.mobiscroll.com/4-10-10/scrollview#opt-themeVariant
            layout: 'fixed',        // More info about layout: https://docs.mobiscroll.com/4-10-10/scrollview#opt-layout
            itemWidth: 134,         // More info about itemWidth: https://docs.mobiscroll.com/4-10-10/scrollview#opt-itemWidth
            snap: false             // More info about snap: https://docs.mobiscroll.com/4-10-10/scrollview#opt-snap
        });

//-----------------Start Listview QUICK NAVIGATION ---------------------
    
	 var timer,
            firstletter,
            currSelected = "A",
            start = new Date(),
            isScrolled = false,
            $wndw = $(window),
            $popup = $('.md-popup'),
            isFavorite = false,
            preventScroll = false,
            $list = $('#demo'),
            $listDeviders = $('#demo li[data-role=list-divider]'),
            $optionList = $('.md-alfabet');
    
        $list.mobiscroll().listview({
            theme: 'ios',                        
            themeVariant: 'light',              
            lang: 'en',                          
            swipe: false,                      
            enhance: true,                
            onItemTap: function (event, inst) {  
                var target = $(event.domEvent.target);
    
                if (target.hasClass('mbsc-ic')) {
                    $(event.target).toggleClass('star3');
                    target
                        .toggleClass('mbsc-ic-star3')
                        .toggleClass('mbsc-ic-star');
                    mobiscroll.toast({
                        
                        message: 'Favorites updated'
                    });
                }
            }
        });

        $optionList.mobiscroll().optionlist({
            theme: 'ios',                       
            themeVariant: 'light',               
            
            type: 'tabs',
            display: 'bottom',                
            select: 'single',                   
            onItemTap: function (event, inst) {  
                var item = $(event.target),
                    text = item.text();
    
                preventScroll = true;
                isFavorite = item.hasClass('md-item-star');
    
                if (!isFavorite) {
                    $('.mbsc-lv-item:not(.star3)', $list).show();
                    $listDeviders.show();
                    $('.md-no-bookmark').hide();
                } else {
                    $('.mbsc-lv-item:not(.star3)', $list).hide();
                    $listDeviders.hide();
                    if (!$('.star3').length) {
                        $('.md-no-bookmark').show();
                    }
                }
    
                if (!isScrolled && !isFavorite) {
                    $wndw.scrollTop($('.header' + text).next().position().top - $(this).height());
                    $popup.addClass('md-show-popup');
                    $popup.text(text);
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        $popup.removeClass('md-show-popup');
                    }, 2000);
                }
            }
        });
    
        $wndw.on('scroll trouchmove', function (ev) {
            if (new Date() - start > 150 && !isFavorite) {
                var currHeader,
                    wTop = $(this).scrollTop();
    
                $listDeviders.each(function (i, v) {
                    if (wTop > $(v).position().top) {
                        currHeader = v;
                        return;
                    }
                });
    
                firstletter = currHeader.textContent;
                isScrolled = true;
    
                if (currSelected != firstletter) {
    
                    $optionList.mobiscroll('navigate', $('.md-item-' + firstletter), true);
                }
    
                currSelected = firstletter;
                start = new Date();
                isScrolled = false;
            }
        });	 

    //-----------------End Listview QUICK NAVIGATION ---------------------
			
  }); // end of document ready
})(jQuery); // end of jQuery name space




